<template>
  <div class="Contact">
    <div class="row">
      <div class="con con1">
        <!--<div class="title">Contact Us</div>-->
<!--        <div v-for="(info, index) in infos" :key="index" class="summary" style="padding-bottom: 5px">-->
<!--          <p class="p">-->
<!--            <b><i>{{ info }}</i></b>-->
<!--          </p>-->
<!--        </div>-->
        <p class="p">
          <b><i>{{ joinUsInfo.infos }}</i></b>
        </p>
      </div>
      <div class="con con1">
        <!--<div class="title">Contact Us</div>-->
        <div class="summary">
          <p class="p">
            联系人: {{ joinUsInfo.contacts }}
          </p>
          <p class="p">
            <span style="font-family:微软雅黑;">邮箱: {{ joinUsInfo.email }}</span>
          </p>
          <p class="p">
            <span style="font-family:微软雅黑;">地址: {{ joinUsInfo.address }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="map">
      <div class="info"><img class="map-img" :src=joinUsInfo.addressMap alt=""></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JoinUsPc',
  props: ['joinUsInfo']
}
</script>

<style lang="css">
.Contact {
  padding: 0px;
  width: 96%;
  margin: 20px auto;
}

.summary {
  text-indent: 2em;
  text-align: left;
  line-height: 25px;
  font-size: 18px;
  color: #3e3a39;
}

.con {
  width: 100%;
  padding: 10px 15px;
  margin: 0px 0px 15px 0px;
  border: 1px solid #cdced0;
  box-sizing: border-box;
  position: relative;
}

.row {
  display: flex;
  justify-content: space-between;
}

.map {
  width: 100%;
}

.map-img {
  border: 0 none;
  vertical-align: top;
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/views/joinus/JoinUsPc.vue